/** CoStar.Api.AptsContentSub.ViewModels.SchoolType */
export var SchoolType;
(function (SchoolType) {
    SchoolType[SchoolType["Unknown"] = 0] = "Unknown";
    SchoolType[SchoolType["Public"] = 1] = "Public";
    SchoolType[SchoolType["Private"] = 2] = "Private";
    SchoolType[SchoolType["Charter"] = 3] = "Charter";
})(SchoolType || (SchoolType = {}));
/** CoStar.Api.AptsContentSub.ViewModels.SchoolLevels */
export var SchoolLevels;
(function (SchoolLevels) {
    SchoolLevels[SchoolLevels["None"] = 0] = "None";
    SchoolLevels[SchoolLevels["PreK"] = 1] = "PreK";
    SchoolLevels[SchoolLevels["Elementary"] = 2] = "Elementary";
    SchoolLevels[SchoolLevels["Middle"] = 4] = "Middle";
    SchoolLevels[SchoolLevels["High"] = 8] = "High";
})(SchoolLevels || (SchoolLevels = {}));
/** CoStar.Api.AptsContentSub.ViewModels.SchoolGrades */
export var SchoolGrades;
(function (SchoolGrades) {
    SchoolGrades[SchoolGrades["None"] = 0] = "None";
    SchoolGrades[SchoolGrades["GradePK"] = 1] = "GradePK";
    SchoolGrades[SchoolGrades["GradeK"] = 2] = "GradeK";
    SchoolGrades[SchoolGrades["Grade1"] = 4] = "Grade1";
    SchoolGrades[SchoolGrades["Grade2"] = 8] = "Grade2";
    SchoolGrades[SchoolGrades["Grade3"] = 16] = "Grade3";
    SchoolGrades[SchoolGrades["Grade4"] = 32] = "Grade4";
    SchoolGrades[SchoolGrades["Grade5"] = 64] = "Grade5";
    SchoolGrades[SchoolGrades["Grade6"] = 128] = "Grade6";
    SchoolGrades[SchoolGrades["Grade7"] = 256] = "Grade7";
    SchoolGrades[SchoolGrades["Grade8"] = 512] = "Grade8";
    SchoolGrades[SchoolGrades["Grade9"] = 1024] = "Grade9";
    SchoolGrades[SchoolGrades["Grade10"] = 2048] = "Grade10";
    SchoolGrades[SchoolGrades["Grade11"] = 4096] = "Grade11";
    SchoolGrades[SchoolGrades["Grade12"] = 8192] = "Grade12";
})(SchoolGrades || (SchoolGrades = {}));
